"use client"
import React, { createContext, useContext, useState, ReactNode, useMemo } from 'react'

interface ModalContextType {
  isModalOpen: boolean
  openModal: () => void
  closeModal: () => void
  toggleModal: () => void
}

const ModalContext = createContext<ModalContextType | undefined>(undefined)

export const useModal = () => {
  const context = useContext(ModalContext)
  if (!context) {
    throw new Error('useModal must be used within a ModalProvider')
  }
  return context
}

interface ModalProviderProps {
  children: ReactNode
}

export const ModalProvider: React.FC<ModalProviderProps> = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const openModal = () => setIsModalOpen(true)
  const closeModal = () => setIsModalOpen(false)
  const toggleModal = () => setIsModalOpen(!isModalOpen)

  // Context value를 memoize하여 불필요한 리렌더링 방지
  const contextValue = useMemo(() => ({
    isModalOpen,
    openModal,
    closeModal,
    toggleModal,
  }), [isModalOpen])

  return (
    <ModalContext.Provider value={contextValue}>
      {children}
    </ModalContext.Provider>
  )
} 